import(/* webpackMode: "eager", webpackExports: ["BonusSpinsDetailsPageClient"] */ "/app/src/app/(pages)/(static)/(rewards)/bonus-spins-details/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/cookies/client.ts");
